import { $api } from "../../../services/request.config";
import { setCurrentDocumentAction } from "../../Requests/CurrentRequest/setCurrentDocument.action";

export const getGroupCurrentRequestThunkAction = (uid, props) => async (dispatch) => {
    try {
        const response = await $api(`/v1/managers/requests/rvd/applications/${uid}`);
        const data = {}

            data["Наименование"] = "Работа в выходной, праздничный день";
            data.typeText = response.data.memo ? "Служебная записка" : "Заявка";


        dispatch(setCurrentDocumentAction({ currentRequestCard: data, currentRequest: response.data }));
    } catch (e) {
        throw  new Error(e?.response);
    }
};
